import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, map, of, switchMap, take, tap, throwError } from 'rxjs';
import { User, UserPagination } from './users.types';
import { environment } from 'app/environment/environment';
import { ApplicantUser } from '../applicant-user/applicant-users.types';

@Injectable({
    providedIn: 'root'
})
export class UserService
{
    // Private
    // private _pagination: BehaviorSubject<UserPagination | null> = new BehaviorSubject(null);
    // private _users: BehaviorSubject<User[] | null> = new BehaviorSubject(null);
    // private _user: BehaviorSubject<User | null> = new BehaviorSubject(null);

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient)
    {
    }

    // get pagination(): Observable<UserPagination>
    // {
    //     return this._pagination.asObservable();
    // }

    // get users(): Observable<User[]>
    // {
    //     return this._users.asObservable();
    // }

    // get user(): Observable<User>
    // {
    //     return this._user.asObservable();
    // }

    
    getUsers1(page: number = 0, size: number = 10, sort: string = 'firstName', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
        Observable<any>
    {
        return this._httpClient.get<{ users: User[] }>(`${environment.API_BASE_PATH}api/user`).pipe(
            tap((response) => {
                //this._pagination.next(response.pagination);
                //this._users.next(response.data.userList);
            })
        );
    }

    getUserById(id: string): Observable<any>
    {
        return this._httpClient.get(`${environment.API_BASE_PATH}api/user/get/${id}`);
    }

    //Create User
    apiPostCreateUser(userModel: User): Observable<any>{
        return this._httpClient.post(`${environment.API_BASE_PATH}api/user/create`, userModel);
    }

    //Update User
    apiPostUpdateUser(userModel: User): Observable<any>{
        return this._httpClient.post(`${environment.API_BASE_PATH}api/user/update`, userModel);
    }

    updateUserStatus(userId: number, status: 'Active' | 'Inactive'): Observable<any> {
        return this._httpClient.post(`${environment.API_BASE_PATH}api/user/status`, {
            userId,
            status
        });
    }

    getUserLists(userType: string, page: number = 0, size: number = 10, search: string = ''):
        Observable<any>
    {
        return this._httpClient.post(`${environment.API_BASE_PATH}api/user/list`,{
            userType: userType,
            pageIndex: page,
            pageSize: size,
            searchText: search
        });
    }

    getPartnerUserList(partnerId, page: number = 0, size: number = 10): Observable<any>{
        return this._httpClient.post(`${environment.API_BASE_PATH}api/user/partner/list`,{
            partnerId: partnerId,
            pageIndex: page,
            pageSize: size
        });
    }

    getBorrowerList(pageIndex: number, pageSize: number, search?: string): Observable<any> {
        return this._httpClient.post(`${environment.API_BASE_PATH}api/user/applicant-list`, {
            pageIndex,
            pageSize,
            searchText: search || ''
        });
    }


    getBorrowerById(userId): Observable<any>{
        return this._httpClient.get(`${environment.API_BASE_PATH}api/user/applicant-list/${userId}`);
    }

    updateBorrower(userModel: ApplicantUser): Observable<any>{
        return this._httpClient.post(`${environment.API_BASE_PATH}api/user/update/applicant-list`,userModel);
    }
}